import { TEC_SICUREZZA } from 'constants/ProjectsConstant';
import { GENERIC_TASKS, TECHNICIAN_TASKS } from './CommonTasks';

export const TEC_SICUREZZA_STEPS = [
  {
    code: TEC_SICUREZZA,
    icon: null,
    order: 1,
  },
];

export const TEC_SICUREZZA_TASKS = [...TECHNICIAN_TASKS, ...GENERIC_TASKS];
